export default {"src":"/_next/static/media/barclays.79cd3965.svg","height":69,"width":64,"blurWidth":0,"blurHeight":0};